import { getMarketplaceBackend } from '../../config/appConfig';
import { postRequest } from '../requests';
import { rejectIfNotOk } from '../api';
import type { ApiSubscribePayload } from './activation.types';

export function subscribe(accountId: string, body: ApiSubscribePayload): Promise<void> {
    return fetch(`${getMarketplaceBackend()}/admin/${accountId}/activations`, postRequest(body)).then(rejectIfNotOk);
}
